const storagePrefix = 'metris_solutionFinder';

const storageService = {
  getItem: <T>(key: string) => {
    if (typeof window !== 'undefined') {
      const value = localStorage.getItem(`${storagePrefix}_${key}`);
      if (value != null) {
        return JSON.parse(value) as T;
      }
    }
    return null;
  },
  setItem: (key: string, value: unknown) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(`${storagePrefix}_${key}`, JSON.stringify(value));
    }
  },
  clearStorage: () => {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  },
};

export default storageService;
